module.exports = __webpack_public_path__ + "img/marketinsights_banner.bcf7f06d.jpg";